/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportGeneratorRequest } from './ReportGeneratorRequest';
import {
    ReportGeneratorRequestFromJSON,
    ReportGeneratorRequestFromJSONTyped,
    ReportGeneratorRequestToJSON,
    ReportGeneratorRequestToJSONTyped,
} from './ReportGeneratorRequest';
import type { ReportExportFormats } from './ReportExportFormats';
import {
    ReportExportFormatsFromJSON,
    ReportExportFormatsFromJSONTyped,
    ReportExportFormatsToJSON,
    ReportExportFormatsToJSONTyped,
} from './ReportExportFormats';
import type { ReportResponseTypes } from './ReportResponseTypes';
import {
    ReportResponseTypesFromJSON,
    ReportResponseTypesFromJSONTyped,
    ReportResponseTypesToJSON,
    ReportResponseTypesToJSONTyped,
} from './ReportResponseTypes';
import type { ReportTypes } from './ReportTypes';
import {
    ReportTypesFromJSON,
    ReportTypesFromJSONTyped,
    ReportTypesToJSON,
    ReportTypesToJSONTyped,
} from './ReportTypes';

/**
 * 
 * @export
 * @interface UndercarriageReportGeneratorRequest
 */
export interface UndercarriageReportGeneratorRequest extends ReportGeneratorRequest {
}



/**
 * Check if a given object implements the UndercarriageReportGeneratorRequest interface.
 */
export function instanceOfUndercarriageReportGeneratorRequest(value: object): value is UndercarriageReportGeneratorRequest {
    return true;
}

export function UndercarriageReportGeneratorRequestFromJSON(json: any): UndercarriageReportGeneratorRequest {
    return UndercarriageReportGeneratorRequestFromJSONTyped(json, false);
}

export function UndercarriageReportGeneratorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageReportGeneratorRequest {
    return json;
}

export function UndercarriageReportGeneratorRequestToJSON(json: any): UndercarriageReportGeneratorRequest {
    return UndercarriageReportGeneratorRequestToJSONTyped(json, false);
}

export function UndercarriageReportGeneratorRequestToJSONTyped(value?: UndercarriageReportGeneratorRequest | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

